import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const balance = async () => {
  try {
    const config: ReturnType = {
      url: 'game-top-ups/balance',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const games = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'game-top-ups/games',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const gameImage = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `game-top-ups/game-image/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {},
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const catalogue = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `game-top-ups/catalogue/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'game-top-ups/curated',
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Product Added',
        showErr: true,
        store: {
          key: args?.state,
          action: 'prepend',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `game-top-ups/curated/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Updated Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `game-top-ups/curated/${args?.id}`,
      method: 'delete',
      authorization: true,
      config: {
        successMsg: 'Removed Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'remove',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'game-top-ups/curated',
      method: 'get',
      params: args.params,
      authorization: true,
      config: {
        showErr: true,
      },
    }
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: 'set',
      }
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const selectedGames = async () => {
  try {
    const config: ReturnType = {
      url: 'game-top-ups/selected-games',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const addSelectedGame = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'game-top-ups/selected-games',
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Game Added',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const removeSelectedGame = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `game-top-ups/selected-games/${args?.id}`,
      method: 'delete',
      authorization: true,
      config: {
        successMsg: 'Game Removed',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default {
  balance,
  games,
  gameImage,
  catalogue,
  create,
  update,
  remove,
  list,
  selectedGames,
  addSelectedGame,
  removeSelectedGame,
}
